export const MATCH_MODES = [
  { value: 'all', label: 'Match ALL rules (AND)' },
  { value: 'any', label: 'Match ANY rule (OR)' },
];

export const DISPATCH_TYPE_DEFAULT = 'feed_automove';

export const DISPATCH_TYPES = [
  { value: 'feed_automove', label: 'Feed Auto-Move', description: 'Condition-driven moves applied to vehicles already in the system on each feed run.' },
  { value: 'incoming', label: 'Incoming (first import)', description: "Sets a vehicle's department the first time it is imported." },
  // hidden: temporarily not offered in the type pickers (execution not built yet)
  {
    value: 'live_automove', label: 'Live Auto-Move', description: 'Reserved for live moves (execution coming later).', hidden: true,
  },
];

export const SELECTABLE_DISPATCH_TYPES = DISPATCH_TYPES.filter(t => !t.hidden);

export const dispatchTypeLabel = (value) => {
  const t = DISPATCH_TYPES.find(o => o.value === value);
  return t ? t.label : (value || DISPATCH_TYPES[0].label);
};

export const FEED_FIELDS = ['stock', 'vin', 'stocktype', 'status', 'make', 'model', 'year', 'body', 'color', 'miles', 'custom_1', 'custom_2', 'custom_3'];

export const VEHICLE_COLUMNS = ['stocktype', 'department_id', 'miles', 'year', 'make', 'model', 'vin', 'stock'];
export const PROPERTY_KEYS = ['certified', 'count_photos'];

export const SOURCE_GROUPS = [
  {
    group: 'vehicle', label: 'Core Vehicle Data', prefix: 'vehicle', items: VEHICLE_COLUMNS, description: 'Columns on the vehicle record already in the system.',
  },
  {
    group: 'feed', label: 'Feed Data', prefix: 'feed', items: FEED_FIELDS, description: 'Normalized values from the incoming feed row.',
  },
  {
    group: 'property', label: 'Vehicle Property', prefix: 'property', items: PROPERTY_KEYS, description: 'Key/value properties stored on the vehicle.',
  },
  {
    group: 'work_item', label: 'Work Item', prefix: 'work_item', items: [], description: 'Fields from the vehicle\'s MPI work items. Matches when any work item on the vehicle matches.',
  },
];

export const sourceLabel = (source) => {
  if (!source) return 'Choose source';
  const [prefix, ...rest] = String(source).split('.');
  const field = rest.join('.');
  const g = SOURCE_GROUPS.find(x => x.prefix === prefix);
  return g ? `${g.label} · ${field}` : source;
};

export const OPERATORS = [
  { value: 'eq', label: 'equals', input: 'text' },
  { value: 'ne', label: 'does not equal', input: 'text' },
  { value: 'lt', label: 'less than', input: 'number' },
  { value: 'lte', label: 'less than or equal to', input: 'number' },
  { value: 'gt', label: 'greater than', input: 'number' },
  { value: 'gte', label: 'greater than or equal to', input: 'number' },
  { value: 'includes', label: 'contains', input: 'text' },
  { value: 'starts_with', label: 'starts with', input: 'text' },
  { value: 'ends_with', label: 'ends with', input: 'text' },
  { value: 'starts_with_letter', label: 'starts with a letter', input: 'none' },
  { value: 'ends_with_letter', label: 'ends with a letter', input: 'none' },
  { value: 'in', label: 'is any of', input: 'list' },
  { value: 'in_department', label: 'is in department', input: 'in_department' },
  { value: 'present', label: 'is present', input: 'none' },
  { value: 'blank', label: 'is blank', input: 'none' },
  { value: 'matches', label: 'matches regex (advanced)', input: 'regex' },
];

export const deptLabel = (d) => {
  if (!d) return '';
  return d.name_alias ? `${d.name} (${d.name_alias})` : d.name;
};

export const EXCLUDED_DEPARTMENT_TYPES = ['data step', 'recently sold', 'parent step', 'all reconditioning'];

export const operatorInput = op => (OPERATORS.find(o => o.value === op) || {}).input || 'text';
export const NUMBER_OPERATORS = OPERATORS.filter(o => o.input === 'number').map(o => o.value);
export const GROUP_DEFAULT = '__group_default__';

// in_department values may hold "@setting:<key>": the department a dealer
// setting points at, resolved per store at runtime. Always saved as the token.
export const SETTING_TOKEN_PREFIX = '@setting:';
export const isSettingToken = v => String(v || '').startsWith(SETTING_TOKEN_PREFIX);
export const settingTokenKey = v => String(v || '').slice(SETTING_TOKEN_PREFIX.length);
